import template from './insuranceFactFindAnswer.html';
import controller from './insuranceFactFindAnswerCtrl.js';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    question: '<',
    answer: '<',
  },
};
